import React, {useEffect, useState} from "react";
import companyLogo from "../assets/yekkada-logo-new.png";

// Profile Icon
const ProfileIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

export default function Header() {
  const [userName, setUserName] = useState("");
  const [clientName, setClientName] = useState("");
  const [lastLoginAt, setLastLoginAt] = useState(null);

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    const storedClientName = localStorage.getItem("client_name");

    if (loggedInUser) {
      setUserName(loggedInUser.userName);
      if (loggedInUser.lastLoginAt) {
        const d = new Date(loggedInUser.lastLoginAt);
        setLastLoginAt(
          d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })
        );
      }
    }

    if (storedClientName) {
      setClientName(storedClientName);
    }
  }, []);

  return (
    <header className="header">

      {/* LEFT: Company Logo */}
      <img className="company-logo" src={companyLogo} alt="Company Logo" />

      {/* CENTER: Client Name */}
      <div className="header-title-container">
        <div className="title-with-icon">
          <h1 className="glowing-title">
            {clientName || "Asset Management System"}
          </h1>
        </div>
      </div>

      {/* RIGHT: User Profile */}
      <div className="user-profile-pill" style={{ marginLeft: "auto" }}>
        <div className="icon-wrapper">
          <ProfileIcon />
        </div>
        <div className="pill-text-group">
          <span className="pill-text">Hello, {userName || "Guest"}</span>
          {lastLoginAt && (
            <span className="pill-last-login">Last login: {lastLoginAt}</span>
          )}
        </div>
      </div>

    </header>
  );
}
